var map = {
	"./AgendasDataProvider.vue": "94ea",
	"./BookSessionsDataProvider.vue": "1c5e",
	"./CategoriesDataProvider.vue": "67dc",
	"./ChatDataProvider.vue": "5364",
	"./CurrentEventDataProvider.vue": "43e2",
	"./DocumentsDataProvider.vue": "302e",
	"./PagesDataProvider.vue": "068e",
	"./PollDataProvider.vue": "f60b",
	"./PublicAgendasDataProvider.vue": "ac2e",
	"./PublicCategoriesDataProvider.vue": "f305",
	"./PublicGroupsDataProvider.vue": "3293",
	"./SpeakersIframeDataProvider.vue": "5ed6",
	"./SponsorDataProvider.vue": "4d2c",
	"./SponsorsDataProvider.vue": "6908",
	"./StreamDataProvider.vue": "fcb3",
	"./TimelineDataProvider.vue": "574f",
	"./UsersDataProvider.vue": "5b56",
	"./VouchersDataProvider.vue": "92c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8a52";